module.exports = __webpack_public_path__ + "img/2_h_uk.acd84793.svg";